import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS } from 'src/app/config/config';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

constructor(
  private http: HttpClient
) { }

sendEmail(email: string, pdfile: string, subjet: string) {
  console.log ('senmail', pdfile);

  const url = URL_SERVICIOS + '/email/' + email + '/' + pdfile + '/' + subjet;
  console.log ( url );
  return this.http.get( url);


}


sendEmailtocliente(email: string,  subjet: string) {


  const url = URL_SERVICIOS + '/enviartocliente/tocliente/' + email  + '/' + subjet;
  console.log ( url );
  return this.http.get( url);


}




sendEmailTuripes(subjet: string) {
  const url = URL_SERVICIOS + '/email_avisosPgos/' +  subjet;
  return this.http.get( url)
  .map ( (resp: any) => {
  return status; }
  );

}


EnviarDatosContacto(nombre: string, email: string, telefono: string, message: string) {

  const url = URL_SERVICIOS + '/recibiremail/' + nombre + '/' + email + '/' + telefono + '/' + message;
  return this.http.get( url)
  .map ( (resp: any) => {
  return status; }
  );

}


nuestraPescadorSeleccionado( valoID: string) {
  console.log ( valoID);

}

}
